export const NETWORKING_RING_COLOR = "#474F56";
export const NETWORKING_CHIP_BACKGROUND = "#BC3323";
export const NETWORKING_CHIP_TEXT = "#FAE7E5";

export type NetworkingBand = {
  key: string;
  label: string;
  description: string;
  min: number;
  max: number;
  /** Distance from the center node, in graph units. */
  radius: number;
  /** Chip background for the band label. */
  chipColor: string;
  ringColor: string;
  ringWidth: number;
};

/** Ordered innermost to outermost. */
export const NETWORKING_BANDS: NetworkingBand[] = [
  {
    key: "level-1",
    label: "Level 1",
    description: "Every connection matches your profile",
    min: 76,
    max: 100,
    radius: 120,
    chipColor: NETWORKING_CHIP_BACKGROUND,
    ringColor: NETWORKING_RING_COLOR,
    ringWidth: 1,
  },
  {
    key: "level-2",
    label: "Level 2",
    description: "Most attributes match your profile.",
    min: 51,
    max: 75,
    radius: 210,
    chipColor: NETWORKING_CHIP_BACKGROUND,
    ringColor: NETWORKING_RING_COLOR,
    ringWidth: 1,
  },
  {
    key: "level-3",
    label: "Level 3",
    description: "A few attributes match your profile.",
    min: 26,
    max: 50,
    radius: 300,
    chipColor: NETWORKING_CHIP_BACKGROUND,
    ringColor: NETWORKING_RING_COLOR,
    ringWidth: 1,
  },
  {
    key: "level-4",
    label: "Level 4",
    description: "Only 1 attribute matches your profile.",
    min: 1,
    max: 25,
    radius: 390,
    chipColor: NETWORKING_CHIP_BACKGROUND,
    ringColor: NETWORKING_RING_COLOR,
    ringWidth: 1,
  },
];

/** Bands are ordered by descending `min`, so the first match is the innermost. */
export function getBandForPercent(percent: number): NetworkingBand {
  const safePercent = Number.isFinite(percent)
    ? Math.min(100, Math.max(0, percent))
    : 0;
  const band = NETWORKING_BANDS.find(
    (candidate) => safePercent >= candidate.min,
  );
  return band ?? NETWORKING_BANDS[NETWORKING_BANDS.length - 1];
}
